(function () {
  if (window.__firgelliAmazonHeader) return;
  window.__firgelliAmazonHeader = true;
  window.__faAmazonHeaderInit = true;

  function apply() {
    var header = document.querySelector("header.bannerHeight, header[role='banner'], header");
    if (!header) return;

    header.classList.remove("fa-header-hide-down");
    header.style.transform = "none";
    header.style.transition = "none";
    header.style.position = "sticky";
    header.style.top = "0";
    header.style.left = "";
    header.style.right = "";
    header.style.width = "100%";
    header.style.zIndex = "10000";
    header.style.willChange = "auto";
    header.style.pointerEvents = "auto";
    header.style.visibility = "visible";
    header.style.height = "auto";

    function updateSpacerHeight() {
      var spacer = document.querySelector(".fa-amazon-header-spacer");
      if (spacer) spacer.style.height = (header.offsetHeight || 0) + "px";
    }

    function pinIfNeeded() {
      var r = header.getBoundingClientRect();
      if (r.top < -1) {
        header.style.setProperty("position", "fixed", "important");
        header.style.setProperty("left", "0", "important");
        header.style.setProperty("right", "0", "important");
        var spacer = document.querySelector(".fa-amazon-header-spacer");
        if (!spacer) {
          spacer = document.createElement("div");
          spacer.className = "fa-amazon-header-spacer";
          spacer.setAttribute("aria-hidden", "true");
          if (header.parentNode) header.parentNode.insertBefore(spacer, header.nextSibling);
        }
      }
      updateSpacerHeight();
    }
    window.addEventListener("scroll", pinIfNeeded, { passive: true });
    window.addEventListener("resize", updateSpacerHeight, { passive: true });
    if (window.ResizeObserver) {
      new ResizeObserver(updateSpacerHeight).observe(header);
    }
    pinIfNeeded();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", apply);
  else apply();
})();
